import { gql } from '@apollo/client';

export const SIGN_UP = gql`
  mutation signup(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $rememberMe: Boolean
    $referralCode: String
  ) {
    signup(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      rememberMe: $rememberMe
      referralCode: $referralCode
    ) {
      __typename
      ... on SignupSuccess {
        success
      }
      __typename
      ... on SignupError {
        validation {
          firstName {
            message
          }
          lastName {
            message
          }
          email {
            message
          }
          phone {
            message
          }
          password {
            message
          }
        }
      }
    }
  }
`;

export const REQUEST_RESET_PASSWORD = gql`
  mutation requestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword(
    $password: String!
    $passwordConfirmation: String!
    $resetToken: String!
  ) {
    resetPassword(
      password: $password
      passwordConfirmation: $passwordConfirmation
      resetToken: $resetToken
    ) {
      ... on UpdatePasswordError {
        validation {
          password {
            message
          }
          passwordConfirmation {
            message
          }
          token {
            message
          }
        }
      }
      ... on UpdatePasswordSuccess {
        success
      }
    }
  }
`;

export const OAUTH_MUTATION = gql`
  mutation oauth(
    $oauthToken: String!
    $tenantId: Int!
    $rememberMe: Boolean
    $referralCode: String
  ) {
    oauth(
      oauthToken: $oauthToken
      tenantId: $tenantId
      rememberMe: $rememberMe
      referralCode: $referralCode
    ) {
      id
    }
  }
`;
